import React from 'react';
import { useLocation } from 'react-router-dom';

// Page transitions removed — instant navigation
export default function PageTransition({ children }) {
  return <>{children}</>;
}
